import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { DashboardStore } from 'src/app/shared/_services/store';
import {
  AuthenticationService,
  ShadowService,
} from '../../../shared/_services';

@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.page.html',
  styleUrls: ['./profile-details.page.scss'],
})
export class ProfileDetailsPage implements OnInit {
  currentUser: any;
  cashier: boolean;
  merchant: boolean;
  subscription: any;
  error: string;
  profileForm: FormGroup;
  loading = false;
  disabled = true;
  accountSummary: any;

  constructor(
    private router: Router,
    private platform: Platform,
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    private shadowService: ShadowService,
    private dashboardStore: DashboardStore,
  ) {
    this.currentUser = this.auth.currentUserValue;
    this.cashier = this.auth.currentUserValue.role === 'cashier';
    this.merchant = this.auth.currentUserValue.role === 'merchant';
    if (this.cashier) {
      this.accountSummary = this.currentUser;
    } else if (
      (this.dashboardStore.getIsNewAccountAdded() === 'true' ||
        this.auth.currentUserValue.details.accounts.length > 0) &&
      this.dashboardStore.getAccountSummary()
    ) {
      this.accountSummary = this.dashboardStore.getAccountSummary();
    } else {
      this.accountSummary = this.dashboardStore.getCurrentUser();
    }
  }

  public errorMessages = {
    cashierName: [
      { type: 'required', message: 'Business Name is required' },
      {
        type: 'maxlength',
        message: 'Business Name cannot be more than 20 characters',
      },
    ],
    address: [{ type: 'required', message: 'Business Address is required' }],
    phone: [
      { type: 'required', message: 'Phone Number is required' },
      { type: 'minlength', message: 'Please enter a valid phone number' },
      { type: 'maxlength', message: 'Please enter a valid phone number' },
      { type: 'pattern', message: 'Please enter only digits' },
    ],
    password: [
      { type: 'required', message: 'Old Password is required' },
      { type: 'minlength', message: 'Password too short' },
      { type: 'pattern', message: '' },
    ],
    newPassword: [
      { type: 'required', message: 'New Password is required' },
      { type: 'minlength', message: 'Password too short' },
      { type: 'pattern', message: '' },
    ],
    confirmPassword: [
      { type: 'required', message: 'Please retype your password' },
      {
        type: 'minlength',
        message: 'Password cannot be less than 8 characters',
      },
      { type: 'pattern', message: '' },
    ],
  };

  get cashierName() {
    return this.profileForm.get('cashierName');
  }

  get businessType() {
    return this.profileForm.get('businessType');
  }

  get address() {
    return this.profileForm.get('address');
  }

  get email() {
    return this.profileForm.get('email');
  }

  get phone() {
    return this.profileForm.get('phone');
  }

  saveProfileDetails() {
    this.router.navigateByUrl('/dashboard');
  }

  updateProfile() {
    this.error = null;
    if (this.profileForm.invalid) {
      return;
    }

    this.loading = true;
    // this.auth.createAccount(this.profileForm.value)
    //   .pipe(first())
    //   .subscribe(
    //     data => {
    //       // this.alertService.success('Registration successful', true);
    //       this.router.navigate(['/'], { queryParams: {registered: true} });
    //       this.loading = false;
    //     },
    //     error => {
    //       this.error = error;
    //       this.loading = false;
    //     });
    console.log(this.profileForm.value);
  }

  goBack() {
    this.router.navigateByUrl('/profile');
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        this.goBack();
      }
    );
  }

  ionViewWillEnter() {
    document.title = 'Profile Details | Bank3D';
    this.shadowService.button();
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.profileForm = this.formBuilder.group({
      cashierName: [
        {
          value: this.accountSummary.details.name,
          disabled: true,
        },
        [Validators.required, Validators.maxLength(20)],
      ],
      address: [this.accountSummary.details.address, Validators.required],
      email: [
        {
          value:
            this.accountSummary.details.email ||
            this.auth.currentUserValue.details.email,
          disabled: true,
        },
      ],
      phone: [
        {
          value: this.accountSummary.details.phone,
          disabled: true,
        },
        [
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
    });
  }
}
